import { useSettings } from '@wu/widget-core';
import { Scrollbars } from 'react-custom-scrollbars-2';
import type { ForecastDailyListItem, RequestResponse } from '../api/request';
import { DailyItem } from './daily-item';

export function Daily({
  data
}: {
  data: RequestResponse<ForecastDailyListItem>;
}) {
  const {
    list = [],
    city: { timezone }
  } = data;
  const { showAllDays } = useSettings();

  const scrollbarHeight = showAllDays ? 56 * list.length : 56 * 3;

  return (
    <Scrollbars
      style={{
        width: '100%',
        height: scrollbarHeight
      }}
    >
      {list.map((item, id) => (
        <DailyItem key={id} id={id} data={item} timezone={timezone} />
      ))}
    </Scrollbars>
  );
}
